import React, { useContext, useRef } from 'react'
import { useCategoryTopListsQuery } from './categoryTopLists.generated'
import TopListCard from './TopListCard'
import styles from './styles.css'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import { Image } from '@deal/components'
import { AnalyticsContext } from '#src/containers/Analytics'
import useOnScreenCallback from '#src/hooks/useOnScreenCallback'
import classnames from 'classnames'

interface Props {
  className?: string
  isVisible?: boolean
}

const TopLists: React.SFC<Props> = ({ className, isVisible = true }) => {
  const navigationContext = useNavigationContext()
  const analytics = useContext(AnalyticsContext)
  const topListRef = useRef<HTMLDivElement>(null)

  const categorySlug = navigationContext?.activeDepartmentSlug || ''

  const { data } = useCategoryTopListsQuery({
    skip: !categorySlug,
    variables: {
      categorySlug
    }
  })

  useOnScreenCallback(topListRef, () => {
    isVisible &&
      analytics?.events.trackTopListModuleViewed({
        location: 'nav-browse'
      })
  })

  const imageUrl = data?.categoryBySlug?.contentAssets.topListNavImage?.imageUrl

  const sellableTopLists = data?.categoryBySlug?.sellableTopLists

  return (
    <div className={classnames(styles.topLists, className)} ref={topListRef}>
      {imageUrl && (
        <Image src={imageUrl} className={styles.image} size="345px" sizeSm="265px" sizeMd="352px" />
      )}
      {sellableTopLists &&
        sellableTopLists.map(topList => (
          <TopListCard
            key={topList.id}
            topList={topList}
            onTopListClicked={() =>
              analytics?.events.trackTopListModuleClicked({
                location: 'nav-browse',
                top_list_clicked_id: topList.id,
                top_list_ids: sellableTopLists.map(sellableTopList => sellableTopList.id)
              })
            }
          />
        ))}
    </div>
  )
}

export default TopLists
